import styled from "@emotion/styled";
import { EmailForm } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form";
import { StyledSignupButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SocialButtons } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons";
import { IconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";

export const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  align-items: start;

  inline-size: 100%;
`;

export const OrDivider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-block-start: 12px;

  color: #000000;
  font-size: 11px;
  text-align: center;
`;

export const StyledSocialButtons = styled(SocialButtons)`
  gap: 12px;
  ${IconContainer} {
    margin-inline-end: 0;
  }
`;

export const StyledEmailForm = styled(EmailForm)`
  ${StyledSignupButton} {
    span {
      position: absolute;
    }
  }
`;
